import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment';

@Pipe({
    name: 'dateConverter',
    standalone: false
})
export class DateConverterPipe implements PipeTransform {
  transform(value: unknown, formGroup: FormGroup): moment.Moment | string {
    if (moment.isMoment(value)) {
      return value;
    }
    if (typeof value === 'string') {
      const v = formGroup.get(value);
      if (v) {
        return v.value;
      }
    }
    return 'PLUTO';
  }
}
